<template>
  <div class="server">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="IP">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.ip" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="分组">
        <el-autocomplete
            v-model="searchForm.groupName"
            @input="search"
            :fetch-suggestions="querySearch"
            placeholder="请输入"
        ></el-autocomplete>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="ip"
            label="IP">
        </el-table-column>
        <el-table-column
            prop="groupName"
            label="分组"
            align="center">
        </el-table-column>
        <el-table-column
            prop="initDate"
            label="初始化时间"
            align="center">
        </el-table-column>
        <el-table-column
            prop="expirationDate"
            label="失效时间"
            align="center">
        </el-table-column>
        <el-table-column
            prop="systemServiceTypeName"
            label="服务器类型"
            align="center">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="IP">
          <el-input v-model="ruleForm.ip" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="分组">
          <el-autocomplete
              style="width: 100%"
              v-model="ruleForm.groupName"
              :fetch-suggestions="querySearch"
              placeholder="请输入"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="初始化时间">
          <el-date-picker
              v-model="ruleForm.initDate"
              type="date"
              style="width: 100%"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker
              style="width: 100%"
              v-model="ruleForm.expirationDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务器类型">
          <el-select v-model="ruleForm.systemServiceType" placeholder="请选择" style="width: 100%">
            <el-option label="数据库服务器" value="0"></el-option>
            <el-option label="Api服务器" value="1"></el-option>
            <el-option label="采集服务器" value="2"></el-option>
            <el-option label="数据缓存服务器" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "server",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        ip: '',
        groupName: '',
      },
      modelTitle: '新增服务器',
      dialogVisible: false,
      ruleForm: {
        name: '',
        ip: '',
        groupName: '',
        initDate: '',
        expirationDate: '',
        systemServiceType: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入药杯型号名称', trigger: 'blur'},
        ],
        devides: [
          {required: true, message: '请输入格子数', trigger: 'change'},
        ],
      },
      restaurants: [],
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增服务器'
      this.ruleForm = {
        name: '',
        ip: '',
        initDate: '',
        groupName: '',
        expirationDate: '',
        systemServiceType: '',
      }
      this.dialogVisible = true
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString) >= 0);
      };
    },
    editorClick(row) {
      this.modelTitle = '编辑服务器'
      this.areaId = row.id
      this.ruleForm = {
        name: row.name,
        ip: row.ip,
        initDate: row.initDate,
        groupName: row.groupName,
        expirationDate: row.expirationDate,
        systemServiceType: String(row.systemServiceType),
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            systemServiceType: Number(this.ruleForm.systemServiceType)
          }
          if (this.modelTitle === '编辑服务器') {
            this.axios
                .put("api/ServiceManage?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                 .post("api/ServiceManage", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteClick(id) {
      let data = {
        id: id
      }
      this.axios
           .delete("api/ServiceManage", {params: data}).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      }).finally(error => {
        this.init()
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    GetGroup() {
      this.axios
          .get("api/ServiceManage/GetGroup")
          .then((res) => {
            this.restaurants = res
            let obj = [];
            this.restaurants.forEach(item => {
              obj.push({
                value: item,
              })
            });
            this.restaurants =obj;
          })
    },
    // list
    init() {
      let data = {
        name: this.searchForm.name,
        ip: this.searchForm.ip,
        groupName:this.searchForm.groupName,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/ServiceManage", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item => {
              switch (item.systemServiceType) {
                case 0:
                  item.systemServiceTypeName = '数据库服务器'
                  break;
                case 1:
                  item.systemServiceTypeName = 'Api服务器'
                  break;
                case 2:
                  item.systemServiceTypeName = '采集服务器'
                  break;
                case 3:
                  item.systemServiceTypeName = '数据缓存服务器'
                  break;
              }
            })
            this.total = res.count
          })
      this.GetGroup()
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.server {

}
</style>